import { fetchRegisteredUsers } from "./registrations";

export const preload = (payload) => async (dispatch, getState) => {
	return Promise.all([dispatch(fetchRegisteredUsers())]).then((res) => {
		return true;
	});
};
